// @ts-check

/** @enum {import('@/types/dataSchemas').KeyAliasKeys} */
export const KeyAliasKeys = /** @type {typeof import('@/types/dataSchemas').KeyAliasKeys} */({
	firstName: 'FIRSTNAME',
	lastName: 'LASTNAME'
});
